import { Component, OnInit } from '@angular/core';
import { MdDialogRef } from '@angular/material'

@Component({
  selector: 'cm-report-text-dialog',
  templateUrl: './report-text-dialog.component.html',
  styleUrls: ['./report-text-dialog.component.css']
})
export class ReportTextDialogComponent implements OnInit {

  public reasonText: string

  constructor(private dialogRef: MdDialogRef<string>) { }

  ngOnInit() {
  }

  report() {
    this.dialogRef.close(this.reasonText)
  }
}



// WEBPACK FOOTER //
// C:/Users/florian.gadal/Workspace/cinenow-web/src/app/profile/report-text-dialog/report-text-dialog.component.ts